import React, { Component } from "react";
import PropTypes from "prop-types";
import Carousel, { consts } from "react-elastic-carousel";
import cx from "classnames";
import { ThumbNail } from "..";
import Button from "./Button/Button";
import * as screenSize from "../../constants/screenSize";
import styles from "./styles.less";

const breakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 420, itemsToShow: 4 },
  { width: 650, itemsToShow: 5 },
  { width: screenSize.DESKTOP_SM, itemsToShow: 5 },
  { width: screenSize.DESKTOP_MD, itemsToShow: 5 },
  { width: screenSize.DESKTOP_LG, itemsToShow: 6 }
];

class CarouselWrapper extends Component {
  state = {
    currentBreakPoint: {}
  };

  getActiveItemIndex = () => {
    const { items, selectedItem } = this.props;
    const itemIndex = items.findIndex(item => item.id === selectedItem);
    return itemIndex || 0;
  };

  onCarouselResize = nextBreakPoint => {
    this.setState(({ currentBreakPoint }) => {
      const widthChanged = currentBreakPoint.width !== nextBreakPoint.width;
      if (widthChanged) {
        return {
          currentBreakPoint: nextBreakPoint
        };
      } else {
        return null;
      }
    });
  };

  renderArrows = ({ type, onClick }) => {
    const { isRtl, isIE } = this.props;
    let pointer;
    if (isRtl) {
      pointer = type === consts.NEXT ? "〉" : "〈";
    } else {
      pointer = type === consts.NEXT ? "〈" : "〉";
    }
    return (
      <Button
        onClick={onClick}
        type={type.toLowerCase()}
        isRtl={isRtl}
        isIE={isIE}
      >
        {pointer}
      </Button>
    );
  };

  render() {
    const {
      items,
      onItemClick,
      selectedItem,
      isRtl,
      titles,
      showClubPrices,
      isIos
    } = this.props;
    const { currentBreakPoint } = this.state;

    const initialFirstItem = this.getActiveItemIndex();
    const moreThanOneItem = currentBreakPoint.itemsToShow > 1;
    const enableScroll = items.length > currentBreakPoint.itemsToShow;

    return (
      <div
        className={cx(styles.Carousel, {
          [styles.rtl]: isRtl,
          [styles.centerMode]: !enableScroll,
          [styles.withArrows]: enableScroll
        })}
      >
        <Carousel
          isRTL={isRtl}
          pagination={false}
          breakPoints={breakPoints}
          initialFirstItem={initialFirstItem}
          onResize={this.onCarouselResize}
          showArrows={enableScroll}
          enableSwipe={enableScroll}
          renderArrow={this.renderArrows}
          ref={ref => (this.carousel = ref)}
        >
          {items.map(item => {
            const isActive = selectedItem === item.id;
            //const isFirstItem = idx === 0;
            //const isLastItem = idx === currentBreakPoint.itemsToShow - 1;
            const shouldPadd = moreThanOneItem; // && !isFirstItem;

            return (
              <div
                key={item.id}
                className={cx(styles.thumbnailWrapper, {
                  [styles.padLeft]: shouldPadd && !isRtl,
                  [styles.padRight]: shouldPadd && isRtl
                })}
              >
                <ThumbNail
                  onClick={onItemClick}
                  product={item}
                  clickable
                  active={isActive}
                  isRtl={isRtl}
                  titles={titles}
                  showClubPrices={showClubPrices}
                  inCarousel={true}
                  isIos={isIos}
                />
              </div>
            );
          })}
        </Carousel>
      </div>
    );
  }
}

CarouselWrapper.propTypes = {
  isIE: PropTypes.bool,
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  items: PropTypes.array,
  selectedItem: PropTypes.string,
  showClubPrices: PropTypes.bool,
  onItemClick: PropTypes.func,
  isIos: PropTypes.bool
};

export default CarouselWrapper;



// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.js